export enum ExtraStatusEnum {
  PENDING = "Invitation Sent",
}
